<template>
  <div>
    <b-modal id="modalActiveFrequent"
      ref="modalActiveFrequent"
      size="md"
      :title="$t('Reactivar retiro frecuente')" 
      ok-variant="outline-success"
      ok-only
      :ok-title="$t('Cerrar')"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer>
        <div>
          <div class="mt-0">
            <form-render ref="formRenderActiveFrequentPickup"
            :fields="fields"
            :form.sync="form"
            @send="activeFrequentPickup">

            </form-render>
          </div>
          <b-button @click="ok" :disabled="loading.activePickup" class="mt-1 push-right" variant="warning">
            {{$t('Activar retiro')}}
            <i v-if="loading.activePickup" :class="['fa', 'fa-spinner', 'fa-spin']"/> 
          </b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TabPickupsService from '../tabPickups.service'
export default {
  props: ['pickup'],
  data () {
    return { 
      fields: [],
      form: {},
      loading: {
        activePickup: false
      },
      localCurrentRequest: {},
      tabPickupsService: new TabPickupsService(this)
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession'
    })
  },
  watch: {
    mySession () {
      if (this.mySession.id) this.setInitialData()
    },
    pickup: {
      handler(newVal) {
        this.localCurrentRequest = newVal
        this.setDataModal()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    setInitialData () {
      this.fields = [
        {
          fieldType: 'FieldDatepicker',
          label: 'Fecha inicio del programa',
          name: 'start_date',
          propsVCalendar: { 
            'min-date': new Date()
          },
          disabledDates: { weekdays: [1, 7] },
          validation: 'requiredDate',
          containerClass: 'col-md-12 container-info',
          clearable: false
        }
      ]
    },
    parseDays(days) {
      const parsed_days = []
      days.forEach(day => {
        switch (day) {
        case 'mon':
          parsed_days.push({ label: 'Lu', text: 'Lunes', id:'mon', calendar_day_id: 2 })
          break
        case 'tue':
          parsed_days.push({ label: 'Ma', text: 'Martes', id:'tue', calendar_day_id: 3 })
          break
        case 'wed':
          parsed_days.push({ label: 'Mi', text: 'Miércoles', id:'wed', calendar_day_id: 4 })
          break
        case 'thu':
          parsed_days.push({ label: 'Ju', text: 'Jueves', id:'thu', calendar_day_id: 5 })
          break
        case 'fri':
          parsed_days.push({ label: 'Vi', text: 'Viernes', id:'fri', calendar_day_id: 6 })
          break
        case 'sat':
          parsed_days.push({ label: 'Sa', text: 'Sabado', id:'sat', calendar_day_id: 7 })
          break
        case 'sun':
          parsed_days.push({ label: 'Do', text: 'Domingo', id:'sun', calendar_day_id: 1 })
          break
        }
      })
      return parsed_days
    },
    setDataModal() {
      delete this.form.start_date
      // Ajuste de los días del calendario "start_date"
      const selected_pickups_calendar_id = this.parseDays(this.localCurrentRequest.pickup_days).map(day => day.calendar_day_id)
      const allDays = [1, 2, 3, 4, 5, 6, 7]
      const unselectedDays = allDays.filter(day => !selected_pickups_calendar_id.includes(day))
      this.fields[this.selectionIndex('start_date')].disabledDates = { weekdays: selected_pickups_calendar_id.length > 0 ? unselectedDays : [1, 7] }
    },
    selectionIndex(name) {
      return this.fields.findIndex(el => el.name === name)
    },
    ok (e) {
      e.preventDefault()
      this.$refs.formRenderActiveFrequentPickup.checkForm()
    },
    activeFrequentPickup(data) {
      this.loading.activePickup = true
      const { first_name, last_name, email, role } = this.mySession
      const payload = {
        start_date: this.$options.filters.jsDateToFormat(data.start_date, 'yyyy-MM-dd'),
        user: {
          first_name,
          last_name,
          email,
          role
        }
      }
      const params = { 
        shipper_id: this.pickup.company.id,
        identifier: this.pickup.identifier
      }
      this.tabPickupsService.callService('reactivateFrequent', payload, params, { fullResponseError: true })
        .then(resp => {
          this.$success('Retiro reactivado correctamente')
          const pickup_response = {
            ...resp.data,
            identifier: this.pickup.identifier
          }
          this.$bvModal.hide('modalActiveFrequent')
          this.$emit('updatePickupStatus', pickup_response)
        })
        .catch(error => {
          console.error(error)
          this.$alert(error.data)
        })
        .finally(() => {
          this.loading.activePickup = false
        })
    }
  }
}
</script>

<style>

</style>